"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logEvent = function (eventDef) { return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    if (event === null) {
        return null;
    }
    return {
        hitType: 'logEvent',
        eventType: event.type,
        eventProperties: event.properties,
    };
}; };
exports.setUserId = function (eventDef) { return function (action, prevState, nextState) {
    var userId = eventDef(action, prevState, nextState);
    return {
        hitType: 'setUserId',
        userId: userId,
    };
}; };
exports.logout = function () { return function () { return [
    {
        hitType: 'setUserId',
        userId: null,
    },
    {
        hitType: 'regenerateDeviceId',
    },
]; }; };
exports.setUserProperties = function (eventDef) { return function (action, prevState, nextState) {
    var userProperties = eventDef(action, prevState, nextState);
    return {
        hitType: 'setUserProperties',
        userProperties: userProperties,
    };
}; };
